var React = require('react');

function LineDesktop2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M199 0V42C199 80.6599 167.66 112 129 112H0","stroke":"white","strokeWidth":"2"}));
}

LineDesktop2.defaultProps = {"width":"200","height":"113","viewBox":"0 0 200 113","fill":"none"};

module.exports = LineDesktop2;

LineDesktop2.default = LineDesktop2;
